<img [src]='"assets/images/ID37_Grafik_Abweichung_"+locale.toLowerCase()+".svg"'
     [default]='"assets/images/ID37_Grafik_Abweichung_en.svg"'
     alt="example of motive curiosity deviates from the norm"/>
